import { Component, ElementRef, HostListener, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { ShopWindowItem } from '../../model/shop-window-item';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ProductService } from '../../services/product.service';

@Component({
    selector: 'pme-packages-mobile',
    templateUrl: './packages-mobile.component.html',
    styleUrls: ['./packages-mobile.component.scss'],
    standalone: false
})
export class PackagesMobileComponent implements OnChanges {
  @Input() activePlanValue: number;
  @Input() activePlanIdentifier: string;
  @Input() isPlan: boolean = false;
  @Input() campaign: boolean = false;
  @Input()
  set packages(value: ShopWindowItem[]) {
    if (!value?.length) return;

    this.packagesFiltered = value;

    let profitable = value.find(pkg => pkg.profitable === true)

    if (!this.selectedOption) {
      this.selectedOption = profitable ? profitable : value[0];
    }

    this.updateButtonState();
    value.forEach(pkg => { if (this.productService.isVariableProduct(pkg.product)) { this.customValue = pkg.baseValue; } });
  }

  @Output() buyClicked = new EventEmitter<{ i: number, customValue: number }>();

  isOpen = false;
  selectedOption: ShopWindowItem | null = null;
  packagesFiltered: Array<ShopWindowItem> = [];

  isActivePlan: boolean = false;
  buttonLabel: string = "Assinar agora";
  hiddenButton: boolean = false;

  constructor(private eRef: ElementRef, private _snackBar: MatSnackBar, public productService: ProductService) { }

  customValue: number = 0;
  showCustomValueError: boolean = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activePlanIdentifier'] || changes['activePlanValue'] || changes['isPlan']) {
      this.updateButtonState();
    }
  }

  private updateButtonState() {
    if (this.isPlan && !this.selectedOption) {
      this.buttonLabel = "Assinar agora";
      this.hiddenButton = false;
      this.isActivePlan = false;
      return;
    }
    if (!this.isPlan) {
      this.buttonLabel = "Comprar créditos";
      this.hiddenButton = false;
      this.isActivePlan = false;
      return;
    }

    this.isActivePlan = this.selectedOption.product?.identifier === this.activePlanIdentifier;

    if (this.isActivePlan) {
      this.buttonLabel = "Você já possui este plano";
      this.hiddenButton = false;
    }
    else if (!this.activePlanIdentifier) {
      this.buttonLabel = "Assinar agora";
      this.hiddenButton = false;
    }
    else if (
      this.activePlanValue > 0 &&
      this.selectedOption.baseValue > this.activePlanValue
    ) {
      this.buttonLabel = "Faça um upgrade";
      this.hiddenButton = false;
    }
    else {
      this.hiddenButton = true;
    }
  }

  toggleSelect() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: ShopWindowItem) {
    if (this.productService.isVariableProduct(option.product) && (!this.customValue || this.customValue === 0)) {
      this.customValue = option.baseValue;
    }
    this.selectedOption = option;
    this.isOpen = false;
    this.updateButtonState();
  }

  onBuyClick() {
    const index = this.packagesFiltered.findIndex(p =>
      p.product?._id === this.selectedOption?.product?._id
    );

    const valorFinal = this.productService.isVariableProduct(this.selectedOption.product)
      ? this.customValue
      : null;

    this.buyClicked.emit({ i: index, customValue: valorFinal });
  }

  updateCustomValue(packageItem: any, value: string) {
    const numValue = Number(value);

    this.customValue = numValue;

    if (this.selectedOption?.product?._id === packageItem.product?._id) {
      this.updateButtonState();
    }
  }

  checkCustomValue(packageItem: ShopWindowItem, event: any) {
    if (this.customValue < packageItem.baseValue) {
      this.customValue = packageItem.baseValue;
      this.showCustomValueError = true;
      this.updateButtonState();
    } else {
      this.showCustomValueError = false;
    }
    this.selectedOption?.featureList.forEach(feature => {
      feature.requests = Math.floor(this.customValue / (Number(feature.toValue?.split("R$ ")[1].replace(",", ".")) || Number(feature.fromValue.split("R$ ")[1].replace(",", "."))));
    })
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    const clickedElement = event.target as HTMLElement;
    const isTriggerClick = clickedElement.closest('#select-consulta-product');

    if (!isTriggerClick) {
      this.isOpen = false;
    }
  }
}